
import CircularProgress from "./CircularProgress";
import "./LoadingSpinner.scss";

import { memo } from 'react';

export default memo(function LoadingSpinner () {
    return (
        <div className="LoadingSpinner__container">
            <CircularProgress className="LoadingSpinner__spinner" />
        </div>
    );
});
